import { Route } from "react-router";
import { LoginPage } from "../pages/LoginPage";
import { ForgotPasswordPage } from "../pages/ForgotPasswordPage";
import UpdatePasswordPage from "../pages/UpdatePasswordPage";

export const AuthRoutes = [
  <Route key="login" path="/login" element={<LoginPage />} />,
  <Route key="forgot-password" path="/forgot-password" element={<ForgotPasswordPage />} />,
  <Route key="update-password" path="/neues-passwort" element={<UpdatePasswordPage />} />,
];
